import api from '../../../api/clinique/_prestation'

export default {
    getTarificationTypeAdmission(data) {
        return new Promise((resolve, reject) => {
            api.getTarificationTypeAdmission(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getTarifActe(type_acte) {
        return new Promise((resolve, reject) => {
            api.getTarifActe(type_acte).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getTarifBilanSante(data) {
        return new Promise((resolve, reject) => {
            api.getTarifBilanSante(data).then(
                response => {
                    resolve(response)
                }, error => {
                    reject(error)
                }
            )
        })
    },

    getConsumableOfConsultation(data){
        return new Promise((resolve,reject) => {
            api.getConsumableOfConsultation(data).then(
                response => {
                    resolve(response)  
                }, error=> {
                    reject(error)
                }
            )
        })
    },

    getTarifPrestation(data) {
        return new Promise((resolve, reject) => {
            api.getTarifPrestation(data).then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },

    getListeBilanSante() {
        return new Promise((resolve, reject) => {
            api.getListeBilanSante().then(
                (response) => {
                    resolve(response);
                },
                (error) => {
                    reject(error);
                }
            );
        });
    },
}